const integer = (value, fallback, field) => {
  if (value === undefined || value === null || value === '') return fallback;
  if ((typeof value !== 'number' && typeof value !== 'string') || !/^\d+$/.test(String(value)) || !Number.isSafeInteger(Number(value)) || Number(value) < 1) {
    throw new Error(`Invalid subscription services ${field}.`);
  }
  return Number(value);
};

// A paginator link supplies pagination metadata, never the request destination.
export const subscriptionCatalogRequest = (values = {}) => {
  const input = values || {};
  const query = input.next_page_url ? new URL(input.next_page_url, 'https://pagination.invalid/').searchParams : new URLSearchParams();
  return {
    page: integer(input.page ?? query.get('page'), 1, 'page'),
    limit: Math.min(integer(input.limit ?? query.get('limit'), 10, 'limit'), 100),
    q: String(input.q ?? query.get('q') ?? ''),
  };
};

export const subscriptionCatalogKey = ({q, limit}) => JSON.stringify([q, limit]);
